import axios from "axios";
const API_URL = process.env.REACT_APP_API;

export async function obtenerTicketsPorEventoService(eventoId: number) {
  try {
    const response = await axios.get(`${API_URL}tickets/por-evento/${eventoId}`);
    const data = response.data?.doc?.data || [];
    return data;
  } catch (error) {
    console.error("Error en obtenerTicketsPorEventoService:", error);
    throw error;
  }
}
